export const getLocaleUrl = (url, locale) => {
    if (url !== '') {
        if (url.includes('/en/')) return url.replace('/en/', `/${locale}/`);
        if (url.includes('/de/')) return url.replace('/de/', `/${locale}/`);
        if (url.includes('/nl/')) return url.replace('/nl/', `/${locale}/`);
    }

    return url;
};
